module.exports = __webpack_public_path__ + "static/media/Tampere-Caribia-ja-Saimaa_kuva_500x500.4729b1d4.jpg";